import { getFirstRouteFromPermissions } from '@/helpers/routePermissions'
import { auth } from '@/services/'

const beforeEnterLogin = async (to, from, next) => {
  const data = auth.getUserAuthData()

  const firstRoute = await getFirstRouteFromPermissions()

  if (data) {
    next(firstRoute)
  } else {
    next()
  }
}

export default beforeEnterLogin
